import { Box } from "@mui/material";
import logo from "assets/tea-logo.png";
import { Trans, useTranslation } from "react-i18next";
import { LINKS } from "shared/config";
import { Button } from "ui";
import { useAuthPersistedStore, useAuthStore } from "shared/store";

const AuthApiError = () => {
  const { t } = useTranslation("Shared");
  const setIsLoggedIn = useAuthPersistedStore((state) => state.setIsLoggedIn);
  const setAuthError = useAuthStore((state) => state.setAuthError);

  const retryLogin = () => {
    setIsLoggedIn(false);
    setAuthError(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh",
        textAlign: "center",
        gap: 4,
      }}
    >
      <img
        src={logo}
        alt="Travel & Expenses Assistant"
        style={{
          width: "200px",
          height: "200px",
        }}
      />
      <span className="mx-5 mb-3 mt-0">
        <Trans i18nKey="auth_error" ns="Shared">
          Error occurred while downloading user data. <br />
          Please try again using the button below.
          <br />
          <br /> If issue persists please raise a ticket via
          <a
            rel="noreferrer"
            className="fw-bolder"
            target="_blank"
            href={LINKS.service_now}
          >
            Service Now
          </a>
          .
        </Trans>
      </span>
      <Button onClick={retryLogin}>{t("buttons.try_again")}</Button>
    </Box>
  );
};

export default AuthApiError;
